const r = [
  "neutral",
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "danger"
], a = [
  "neutral--light-5",
  "neutral--light-4",
  "neutral--light-3",
  "neutral--light-2",
  "neutral--light-1",
  "neutral",
  "neutral--dark-1",
  "neutral--dark-2",
  "neutral--dark-3",
  "neutral--dark-4",
  "neutral--dark-5",
  "primary--light-2",
  "primary--light-1",
  "primary",
  "primary--dark-1",
  "primary--dark-2",
  "secondary--light-2",
  "secondary--light-1",
  "secondary",
  "secondary--dark-1",
  "secondary--dark-2",
  "success--light-2",
  "success--light-1",
  "success",
  "success--dark-1",
  "success--dark-2",
  "info--light-2",
  "info--light-1",
  "info",
  "info--dark-1",
  "info--dark-2",
  "warning--light-2",
  "warning--light-1",
  "warning",
  "warning--dark-1",
  "warning--dark-2",
  "danger--light-2",
  "danger--light-1",
  "danger",
  "danger--dark-1",
  "danger--dark-2"
];
export {
  r as baseColorDesignTokens,
  a as colorDesignTokens
};
